export const signCampfireLti = /* GraphQL */ `
  query SignCampfireLTI(
    $input: ControllerInput!
    $authorizationContext: AuthorizationContextInput
  ) {
    signCampfireLti(
      input: $input
      authorizationContext: $authorizationContext
    ) {
      signature
    }
  }
`;

export const toggleAppLicense = /* GraphQL */ `
  mutation ToggleAppLicense($input: ControllerInput!) {
    toggleAppLicenseAction(input: $input) {
      id
      sk
    }
  }
`;

export const signContentItemSelectionLti = /* GraphQL */ `
  query SignContentItemSelectionLTI(
    $input: ControllerInput!
    $authorizationContext: AuthorizationContextInput
  ) {
    signContentItemSelectionLti(
      input: $input
      authorizationContext: $authorizationContext
    ) {
      signature
    }
  }
`;

export const registerContent = /* GraphQL */ `
  mutation RegisterContent(
    $input: ControllerInput!
    $authorizationContext: AuthorizationContextInput
  ) {
    registerContent(
      input: $input
      authorizationContext: $authorizationContext
    ) {
      success
      userErrorMessage
    }
  }
`;

export const deregisterContent = /* GraphQL */ `
  mutation DeregisterContent(
    $input: ControllerInput!
    $authorizationContext: AuthorizationContextInput
  ) {
    deregisterContent(
      input: $input
      authorizationContext: $authorizationContext
    ) {
      success
      userErrorMessage
    }
  }
`;

export const listContentLicensesForUser = /* GraphQL */ `
  query ListContentLicensesForUser(
    $input: ListResourcesByIdThenSkInput!
    $authorizationContext: AuthorizationContextInput
  ) {
    listContentLicenses(
      input: $input
      authorizationContext: $authorizationContext
    ) {
      items {
        id
        sk
        name
      }
      nextToken
    }
  }
`;
